/**
 * The external dependencies.
 */
import {pathOr} from 'ramda'
/**
 * The internal dependencies.
 */
import {toString} from '../../common/utilities';

/**
 * Check whether the specified request is running.
 *
 * @param  {Object}           state
 * @param  {String|Function}  request
 * @return {Boolean}
 */
export function isRequestRunning(state, request) {
    return pathOr(false, [
        'requests',
        'items',
        toString(request),
        'running'
    ], state);
}

/**
 * Get the error occured during a network request.
 *
 * @param  {Object}           state
 * @param  {String|Function}  request
 * @return {String}
 */
export function getRequestError(state, request) {
    return pathOr('', [
        'requests',
        'items',
        toString(request),
        'error'
    ], state);
}

/**
 * Get the success message for a network request.
 *
 * @param  {Object}           state
 * @param  {String|Function}  request
 * @return {String}
 */
export function getRequestSuccess(state, request) {
    return pathOr('', [
        'requests',
        'items',
        toString(request),
        'success'
    ], state);
}



// WEBPACK FOOTER //
// ./src/store/requests/selectors.js